const getHtmlElementId = (prefix,regionCode='',suffix) => {
    if(!prefix) return ''
    const cleanPrefix = prefix.replace(/[^a-zA-Z-_ ]/g, '').replace(/([-]|\s)/g, '_')
    const prefixPart = `${cleanPrefix}_`
    const regionCodePart = regionCode ? `${regionCode}_`: ''
    return `${prefixPart}${regionCodePart}${suffix}`.toLocaleLowerCase()
  }
  
  export const getLinkId = (prefix,regionCode='') => {
    return getHtmlElementId(prefix,regionCode,'link')
  }
  
  export const getButtonId = (prefix,regionCode='') => {
    return getHtmlElementId(prefix,regionCode,'btn')
  }